import React from "react";
import { FaSpinner } from "react-icons/fa";

const DataOutlet = ({ total, name, icon, loading }) => {
  return (
    <>
      <div className="flex flex-col gap-2 rounded-[10px] bg-amber-700 p-4 h-32">
        <div className="flex items-center justify-between rounded-full">
          <span className="text-body-sm font-medium text-gray-300 md:text-[20px]">
            {name}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <div className="min-h-[24px] flex items-center justify-center">
            {icon}
          </div>
          <h4 className="mb-1.5 text-heading-6 font-bold text-2xl text-white flex-grow-0">
            {loading ? (
              <div className="flex justify-center items-center h-[24px]">
                <FaSpinner className="animate-spin" color="light" />
              </div>
            ) : (
              total
            )}
          </h4>
        </div>
      </div>
    </>
  );
};

export default DataOutlet;
